const colors = () => ({
  white: '#ffffff',
  mainGreen: '#49b79a',
  mainBlue: '#467afb',
  mainGray: '#f5f8fe',
  lightGray: '#f2f3f3',
  lightGreen: '#f1fafa',
  statusGreen: '#00d7a3',
  statusRed: '#f12003',
  statusYellow: '#ffcc00',
  redError: '#ff4848',
  fucsia: '#ea2792',
  transparent: 'transparent',
  logo: '#595959',
  buttonTextColor: '#e6007e',
  backgroundOpacity: 'rgba(255,255,255,0.81)',
  blackOpacity: 'rgba(0, 0, 0, 0.05)',
  greenGradient: 'linear-gradient(79deg, #00d7a3, #00d7ca 54%, #00d7a3)',
  grayText: '#919397',
  lightGray2: '#ececed',
  statusBgRed: '#f5a1a1',
  lightBlue: '#c7d4f5',
  statusBgGreen: 'rgba(0, 173, 62, 0.16)',
  statusText: '#00ad3e',
  aquamarine: '#00d7a3',
  greyBg: 'rgba(218, 219, 223, 1)',
  lightGray3: '#f0f0f0',
  iconBackgroundGray: '#ECECEC',
  darkGray: '#8e8e93',
  fadedGray: '#b0bfcc',
  darkGreen: '#49b696',
  borderGreen: '#0BD8A7',
  statusBgGreen1: '#E5F8F5',
  menuShadow: 'rgb(107 217 212 / 67%)',
  blueShadow: 'rgba(70, 122, 251, 0.4)',
  lighterWhite: 'rgba(255, 255, 255, 0.64)',
  almostWhite: 'rgba(255, 255, 255, 0.9)',
  violet: '#a358f8',
  lightViolet: '#dbdef6',
  darkViolet: '#643a71',
  lightGray4: '#c5c5c5',
  lighterGreen: '#7ad199',
  yellow: '#f5cb00',
  almostBlack: '#83858a',
  lightGreenBgNoOpacity: '#cce7da',
  lightOrange: '#f29339',
  lightOrangeBackground: '#ffe4cf',
  orangeStatusText: '#ff7c00',
  purpleStatusText: '#a358f8',
  quiteBlue: 'rgba(70, 122, 251, 0.16)',
  picTransparent: '#d7eeef',

  /* Zeplin's Palette  */

  bubble: {
    one: 'rgb(70, 122, 251)',
    two: 'rgb(125, 161, 252)',
    three: 'rgb(181, 202, 253)',
    four: 'rgb(218, 228, 254)'
  },

  blue: {
    one: '#467afb',
    two: '#6692ff',
    three: '#89bbff',
    four: '#c7e4ff',
    five: 'rgba(70, 122, 251, 0.08)',
    six: 'rgba(70, 122, 251, 0.12)'
  },
  pink: {
    one: '#e6007e',
    two: 'rgba(230, 0, 126, 0.08)',
    three: '#fdebf5'
  },
  black: {
    one: '#070b15',
    two: 'rgba(7, 11, 21, 0.75)',
    three: 'rgba(7, 11, 21, 0.5)',
    four: 'rgba(7, 11, 21, 0.2)',
    five: 'rgba(7, 11, 21, 0.08)',
    six: '#000',
    seven: 'rgba(0, 0, 0, 0.08)',
    eight: 'rgba(7, 11, 21, 0.16)',
    nine: '#484d6d'
  },
  semantic: {
    primary: '#f29339',
    secondary: '#f75959',
    tertiary: '#00ad3e',
    redBg: 'rgba(247, 89, 89, 0.16)',
    orangeBg: '#e8e5d5'
  },
  gradient: {
    cta: 'linear-gradient(45deg, #00d7a3, #00d7ca 54%, #00d7a3)',
    primary: 'linear-gradient(45deg, #00d7ca, #00d7a3)',
    hover:
      'linear-gradient(to bottom, rgba(255, 255, 255, 0.64) 0%, rgba(255, 255, 255, 0.48))',
    backButton: 'linear-gradient(265deg, #49b696 86%, #48bab9 16%)',
    corporate: 'linear-gradient(#4eb8ff,#2361ff)',
    checkbox: 'linear-gradient(135deg, #7cb2fd, #467afb)',
    dashboardCards:
      'linear-gradient(to bottom, rgba(222, 222, 222, 0.64), rgba(255, 255, 255, 0.16))'
  },
  whiteShade: {
    one: 'rgba(255, 255, 255, 0.52)'
  },
  status: {
    redBg: 'rgba(254, 233, 233, 0.6)',
    greenBg: 'rgba(221, 250, 243, 0.6)',
    greyBg: 'rgba(142, 142, 147, 0.16)',
    orangeBg: 'rgba(246, 152, 51, 0.15)'
  }
});

export default colors;
